"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _ZoomToAllFeaturesButton = _interopRequireDefault(require("../../../button/zoom/ZoomToAllFeaturesButton/ZoomToAllFeaturesButton"));

var _ZoomToSelectedFeaturesButton = _interopRequireDefault(require("../../../button/zoom/ZoomToSelectedFeaturesButton/ZoomToSelectedFeaturesButton"));

var _ClearAllFeaturesButton = _interopRequireDefault(require("../../../button/feature/ClearAllFeaturesButton/ClearAllFeaturesButton"));

var _ClearSelectedFeaturesButton = _interopRequireDefault(require("../../../button/feature/ClearSelectedFeaturesButton/ClearSelectedFeaturesButton"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureGridMenuBar = function FeatureGridMenuBar(_ref) {
  var map = _ref.map,
      layer = _ref.layer,
      gridApi = _ref.gridApi;
  var zoomMenu = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Menu, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ZoomToAllFeaturesButton.default, {
        type: "text",
        map: map,
        vectorLayer: layer,
        children: "Zoom All"
      })
    }, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ZoomToSelectedFeaturesButton.default, {
        type: "text",
        map: map,
        gridApi: gridApi,
        children: "Zoom to Selected Feature(s)"
      })
    }, "2")]
  });
  var clearMenu = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Menu, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ClearAllFeaturesButton.default, {
        type: "text",
        vectorLayer: layer,
        children: "Clear All"
      })
    }, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Menu.Item, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ClearSelectedFeaturesButton.default, {
        type: "text",
        gridApi: gridApi,
        vectorLayer: layer,
        children: "Clear Selected Feature(s)"
      })
    }, "2")]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.default.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Space, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Dropdown, {
        overlay: clearMenu,
        placement: "bottomLeft",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
          children: "Clear"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Dropdown, {
        overlay: zoomMenu,
        placement: "bottomLeft",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
          children: "Zoom"
        })
      })]
    })
  });
};

var _default = FeatureGridMenuBar;
exports.default = _default;